import { Controller, useForm } from "react-hook-form"
import DialogComponent from "../../../../../components/dialog-component/dialog-component"
import { ManuallyScheduleModalProps } from "./types"
import { ModalBaseForm, ModalButtonsContainer } from "../../../../../components/dialog-component/dialog-component.styles"
import { PrimaryButton } from "../../../../../components/button/button"
import { useContext, useState } from "react"
import { timeSlotValidation } from "../../../../../utils/validations"
import { yupResolver } from "@hookform/resolvers/yup"
import { StepperDataContext } from "../../../context/stepper-context"
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { TimeField } from "@mui/x-date-pickers"
import { Typography } from "@mui/material"

const ModalBody: React.FC<{
    onClose: () => void
}> = ({
    onClose
}) => {
        const { setSelectedTimeSlot } = useContext(StepperDataContext)
        const [isLoading, setIsLoading] = useState<boolean>(false)

        const { control, watch, formState: { errors, isValid } } = useForm({
            mode: "all",
            resolver: yupResolver(timeSlotValidation()),
        })

        const handleSubmit = () => {
            const { date, fromTime, toTime } = watch()
            if (date && fromTime && toTime) {
                setIsLoading(true)
                // @ts-ignore
                const fomattedDate = date.format('YYYY-MM-DD')
                const start = `${fomattedDate} ${fromTime}`
                const end = `${fomattedDate} ${toTime}`

                setSelectedTimeSlot({
                    start,
                    end,
                    isManuallySelected: true
                })
                onClose && onClose()
            }
        }

        const isValidForm = isValid

        return (
            <ModalBaseForm>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                        name="date"
                        control={control}
                        render={({ field }) => (
                            <DateCalendar
                                {...field}
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(newValue) => field.onChange(newValue)}
                                views={['year', 'month', 'day']}
                            />
                        )}
                    />
                    {errors.date && <p>{errors.date.message}</p>}

                    <div className="time-picker">
                        <div>
                            <Typography>From</Typography>
                            <Controller
                                name="fromTime"
                                control={control}
                                render={({ field }) => (
                                    <TimeField
                                        {...field}
                                        value={field.value ? dayjs(field.value, 'HH:mm:ss') : null}
                                        onChange={(newValue) => field.onChange(newValue?.format('HH:mm:ss'))}
                                    />
                                )}
                            />
                            {errors.fromTime && <p>{errors.fromTime.message}</p>}
                        </div>

                        <div>
                            <Typography>To</Typography>
                            <Controller
                                name="toTime"
                                control={control}
                                render={({ field }) => (
                                    <TimeField
                                        {...field}
                                        value={field.value ? dayjs(field.value, 'HH:mm:ss') : null}
                                        onChange={(newValue) => field.onChange(newValue?.format('HH:mm:ss'))}
                                    />
                                )}
                            />
                            {errors.toTime && <p>{errors.toTime.message}</p>}
                        </div>
                    </div>
                </LocalizationProvider>
                <ModalButtonsContainer>
                    <PrimaryButton isLoading={isLoading} disabled={!isValidForm} onClick={handleSubmit}>Select and Continue</PrimaryButton>
                </ModalButtonsContainer>
            </ModalBaseForm>
        )
    }

const ManuallyScheduleModal: React.FC<ManuallyScheduleModalProps> = ({ open, onClose }) => {
    return (
        <DialogComponent
            title="Manual schedule"
            content={
                <ModalBody
                    onClose={onClose}
                />
            }
            open={open}
            onClose={onClose}
        />
    )
}

export default ManuallyScheduleModal